// API Configuration
// Use localhost in development, IP address in production
const isDevelopment = process.env.NODE_ENV === 'development';
export const _baseURL = isDevelopment
    ? 'http://localhost:50028/api/'
    : 'http://13.125.178.7:50028/api/';

// Helper function to build full API URL
export const getApiUrl = (endpoint) => {
    return `${_baseURL}${endpoint}`;
};
